import { createContext, useContext } from "solid-js";

/**
 * A message's activity timeline, as the status line under the turn sees it. Provided per message,
 * since each message owns its own timeline; absent outside one.
 */
interface ActivityFocus {
  /** Expands the timeline, then the card that holds the operation, and scrolls to it. */
  open(operationId: string): void;
  /** Every row is on screen: the timeline is expanded inline or open in the side panel. */
  isOpen(): boolean;
}

export const ActivityFocusContext = createContext<ActivityFocus>();

export const useActivityFocus = () => useContext(ActivityFocusContext);
